import { render, staticRenderFns } from "./competitiveSales.vue?vue&type=template&id=4adb967c&scoped=true"
import script from "./competitiveSales.vue?vue&type=script&lang=js"
export * from "./competitiveSales.vue?vue&type=script&lang=js"
import style0 from "./competitiveSales.vue?vue&type=style&index=0&id=4adb967c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb967c",
  null
  
)

export default component.exports